<!--日清周结首页-->
<template>
    <div class="app-container">
        <div class="file-title-container">
            高中题库(三层量分定做)
        </div>
        <div class="rqzj-base-container">
            <div class="subject-par-container">
                <div class="subject-item" @click="goToManager('22')">数 学</div>
                <div class="subject-item" @click="goToManager('28')">物 理</div>
                <div class="subject-item" @click="goToManager('27')">化 学</div>
            </div>
        </div>
    </div>
</template>
<script>
import {serviceUrl} from "@/utils/global";

export default {
    name: "sclfdzIndex",
    components: {},
    data() {
        return {
            serviceUrl,
        }
    },
    computed: {},
    watch: {},
    created() {

    },
    mounted(){},
    methods: {
        goToManager(subjectKey){
            this.$router.push({
                path: "/sclfdzManager",
                query: {
                    subject: subjectKey,
                }
            });
        }
    }
}
</script>
<style>
.rqzj-base-container{
    width: 100%;
    height: calc(100vh - 140px);
    background-color: #fff;
    overflow-y: auto!important;
    padding-bottom: 10px;
    padding-top: 5px;
    font-family: sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
}
.file-title-container{
    width: 100%;
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
    background-color: #fff;
}

.subject-par-container{
    width: 100%;
    height: 100px;
    padding: 0 20px 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;

}
.subject-item{
    width: 200px;
    height: 100%;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
    display: grid;
    place-items: center;
    margin-right: 30px;
    font-size: 18px;
    font-weight: bold;
    border: 1px solid #ff7f2e;
    color: #ff7f2e;
    cursor: pointer;
    border-radius: 10px;
}

.subject-item:hover{
    color: #fff!important;
    background: #ff7f2e!important;
    border: 1px solid #ff7f2e;
}
</style>